import newAPIService from './newAPIService';

type SummaryCounters = {
    numberOfJobs: number
    numberOfTodayJobs: number
    numberOfUsers: number
    numberOfTodayWatchedCV: number
};
export const summaryCount = async () => newAPIService.get<SummaryCounters>('/api/home/summaryCount');

export const getUserSearchKeys = async (
    params: {userId},
) => newAPIService.get<string[]>(`/user-search-keys/${params.userId}`);

export const deleteUserSearchKeys = async (
    params: {userId, searchKeyId},
) => newAPIService.delete<string[]>(`/users/${params.userId}/search-keys/${params.searchKeyId}`);
